export const products = [
    {
        days: '30',
        money: 28,
        product: 'P1'
    },
    {
        days: '91',
        money: 81,
        product: 'P2'
    },
    {
        days: '183',
        money: 159,
        product: 'P3'
    },
    {
        days: '365',
        money: 268,
        product: 'P4'
    },
    {
        days: '0',
        money: 15,
        product: 'P5'
    }
];
export const convertBtoGB = (bytes: number): number => {
    return bytes / (1024 * 1024 * 1024);
};
